export default __webpack_public_path__ + "static/fendy-7837232c14bd11409802a03d2d6bc5ea.webp";